export default "__VITE_ASSET__8RoAk$Sn__"